<template>
  <div>
    <div class="noOrder">
      <div class="inputSearch" v-if="orderList.length">
        <div class="block">
          <el-date-picker
            v-model="dataPickerValue"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="small"
            @change="dataPickerValueChange"
          >
          </el-date-picker>
        </div>
      </div>
      <table
        style="border-collapse: separate; border-spacing: 0px 20px"
        v-if="orderList.length"
      >
        <thead>
          <tr>
            <th v-for="(item, index) in list.title" :key="index">
              {{ item }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in orderList" :key="item.id">
            <td>{{ item.billdate }}</td>
            <td>{{ item.Number }}</td>
            <td class="money">￥{{ parseFloat(item.Total).toFixed(2) }}</td>
            <td>
              {{ item.billstate }}
            </td>
            <td>
              <a
                @click="wlstateChang(item.transtype, item.kdnum, 2)"
                href="javascript:void(0);"
                class="orderLink"
                :style="
                  item.wlstate == '未发出'
                    ? 'color:#e4040b;font-size:14px;font-weight: 600;'
                    : 'color:#3385ff;font-size:14px;font-weight: 600;'
                "
                >{{ item.wlstate }}</a
              >
            </td>
            <td class="tdNoData">
              <div v-if="item.fpstate == '不开票'">{{ item.fpstate }}</div>
              <div
                class="kpBtn s"
                v-else-if="item.fpstate == '申请开票'"
                @click="applyChange(item.Number)"
              >
                {{ item.fpstate }}
              </div>
              <div class="kpBtn y" v-else-if="item.fpstate == '已开票'">
                {{ item.fpstate }}
              </div>
              <div class="kpBtn ysq" v-else-if="item.fpstate == '已申请'">
                {{ item.fpstate }}
              </div>
            </td>
            <td class="tdNoData tdW">
              <i
                class="el-icon-document"
                @click="orderListChange(item.Number)"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else><el-empty description="暂无订单数据"></el-empty></div>
      <div class="paginationBox" v-if="orderList.length">
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="index"
            :page-sizes="[10, 15, 20, 25]"
            :page-size="pageSize"
            layout="prev, pager, next, jumper, sizes , total"
            :total="totalSize"
            prev-text="上一页"
            next-text="下一页"
          >
          </el-pagination>
        </div>
      </div>
      <div class="p_wrap" v-show="isStock">
        <div class="w_box">
          <div class="stock">
            <img src="../images/weifachubeihuoneirong.png" alt="" />
          </div>
          <div class="close" @click="closeChange">
            <img src="../images/weifachubeihuoguanbianniu.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="M" v-show="isStock"></div>
  </div>
</template>

<script>
import { getBillList, chenkpaybill } from "@/api";
export default {
  props: {
    msg: Array,
  },
  data() {
    return {
      dataPickerValue: "",
      totalSize: null,
      index: 1, //默认第一页
      pageSize: 10, //默认展示10条数据
      list: {
        title: [
          "订单日期",
          "订单编号",
          "金额",
          "收货人",
          "物流状态",
          "发票状态",
        ],
      },
      orderListAll: [],
      orderList: [],
      isStock: false,
    };
  },
  methods: {
    payment(id) {
      console.log(id);
    },
    wlstateChang(transtype, kdnum, i) {
      if (kdnum) {
        this.$router.push({
          path: "/physical",
          query: {
            transtype,
            kdnum,
          },
        });
        this.$store.commit("changeIndex", i);
      } else {
        this.isStock = true;
      }
    },
    orderListChange(Number) {
      this.$router.push({
        path: "/inventory",
        query: {
          type: 2,
          Number,
        },
      });
    },
    closeChange() {
      this.isStock = false;
    },
    async getBillLists(begindate, enddate) {
      let token = window.sessionStorage.getItem("token");
      let usercode = window.sessionStorage.getItem("usercode");
      const res = await getBillList({
        usercode,
        token,
        flag: "3",
        begindate,
        enddate,
      });
      this.orderListAll = JSON.parse(res.data);
      this.getList();
    },
    getList() {
      this.orderList = this.orderListAll.filter(
        (item, index) =>
          index < this.index * this.pageSize &&
          index >= this.pageSize * (this.index - 1)
      );
      this.totalSize = this.orderListAll.length;
    },
    /**
     * @name: 分页
     */
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.index = val;
      this.getList();
    },
    dataPickerValueChange() {
      if (this.dataPickerValue !== null) {
        this.getBillLists(this.dataPickerValue[0], this.dataPickerValue[1]);
      } else {
        this.getBillLists("", "");
      }
    },
    async applyChange(billno) {
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      const { data: res } = await chenkpaybill({
        usercode,
        token,
        billno,
        flag: "2",
      });
      let result = JSON.parse(res)[0];
      if (result.code !== 200) {
        this.$notify.error({
          title: "错误",
          message: result.message,
          duration: 2000,
        });
      } else {
        this.$notify({
          title: "成功",
          message: result.message,
          type: "success",
          duration: 2000,
        });
        this.getBillLists();
      }
    },
  },
  mounted() {
    this.getBillLists("", "");
  },
  watch: {
    msg(val) {
      this.getBillLists();
    },
  },
};
</script>
<style lang='less' scoped>
.M {
  width: 100%;
  height: 1780px;
  position: fixed;
  top: 0;
  right: 0;
  background: rgba(211, 210, 215, 0.5);
  z-index: 0;
}
.noOrder {
  padding: 30px;
  margin-bottom: 180px;
  position: relative;
  .p_wrap {
    z-index: 1;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 750px;
    height: 450px;
    .w_box {
      position: relative;
      .stock {
        width: 750px;
        height: 450px;
        background: url(../images/weifachubeihuobaidi.png) no-repeat;
      }
      .close {
        position: absolute;
        right: 4px;
        top: -12px;
        width: 33px;
        height: 33px;
        cursor: pointer;
      }
    }
  }
  .paginationBox {
    padding-top: 40px;
    .block {
      text-align: center;
    }
  }
  .inputSearch {
    text-align: right;
    padding-bottom: 18px;
    border-bottom: 1px dashed #cacbcd;
  }
  .tdNoData {
    width: 100px !important;
    .kpBtn {
      width: 115px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #fff;
      margin: 0 auto;
      border-radius: 2px;
    }
    .s {
      cursor: pointer;
      background: #235ff5;
    }
    .y {
      background: #709ee5;
    }
    .ysq {
      background: #3385ff;
    }
    i {
      font-size: 20px;
      display: inline-block;
      padding: 0 10px;
    }
  }
  table tr th {
    width: 160px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #747577;
  }
  table tbody tr {
    background: #fff;
  }
  table tbody tr td {
    width: 202px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  table tbody tr {
    .money {
      color: #333333;
      font-weight: 600;
    }
    .orderLink {
      text-decoration: underline;
      font-size: 12px;
      font-weight: 600;
    }
    .orderLink.link_red {
      color: #e4040f;
    }
    .orderLink.link_blue {
      color: #3585ff;
    }
    .orderLink.link_h {
      color: #7b7b7b;
    }
  }
}
</style>